import React from 'react';
import * as assets from '@assets';
import useQueryString from '@hooks/useQueryString';
import { CapaQuotationServiceType } from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestQueryString } from '../types';
import RequestFormFileInputLayout from './RequestFormFileInput';
import { useSelector } from 'react-redux';
import { RootState } from '@modules/index';

const DesignReferenceFileInput: React.FC = () => {
  const numberOfFiles = useSelector<RootState, number>(
    (state) => (state.request?.referenceFiles ?? []).length
  );
  const {
    query: { serviceType }
  } = useQueryString<RequestQueryString>();

  return (
    <FormInputLayout
      label="참고파일"
      required={true}
      description={'(jpg, jpeg, png, pptx, pdf, hwp 최대 용량 10M)'}
      limit={20}
      valueLength={numberOfFiles}
    >
      <RequestFormFileInputLayout
        serviceType={serviceType as CapaQuotationServiceType}
        quantityLimit={20}
        sizeLimitMB={10}
        type="designReference"
        acceptFileFormats=".jpg, .jpeg, .png, .pptx, .pdf, .hwp"
        icon={
          <img
            src={assets.DesignReferenceFileInputIcon}
            width="62"
            height="56"
            alt="참고파일 업로드"
          />
        }
        title={
          <CustomizedTypography
            variant="subtitle1"
            fontWeight="500"
            color="textPrimary"
            gutterBottoms={8}
            align="center"
          >
            프로젝트 이해에 도움이 되는 <br />
            파일을 끌어다 놓으세요.
          </CustomizedTypography>
        }
        onDragText={
          <>
            <CustomizedTypography
              variant="subtitle1"
              fontWeight="500"
              color="textPrimary"
              gutterBottoms={4}
            >
              끌어다 놓으세요.
            </CustomizedTypography>
            <CustomizedTypography variant="body1" color="textPrimary">
              20장까지 업로드할 수 있습니다.
            </CustomizedTypography>
          </>
        }
        description={
          <CustomizedTypography
            variant="body1"
            color="textPrimary"
            gutterBottoms={30}
          >
            20장까지 업로드할 수 있습니다.
          </CustomizedTypography>
        }
      />
    </FormInputLayout>
  );
};

export default DesignReferenceFileInput;
